import { render } from "./ServiceStatement.vue?vue&type=template&id=2e8c6400"
import script from "./ServiceStatement.vue?vue&type=script&lang=js"
export * from "./ServiceStatement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__